/* ===========================================================
   LA FIRMA — Theme Interactions
   =========================================================== */
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.lf-header');
  var menuBtn = document.querySelector('[data-lf-menu-toggle]');
  var menuClose = document.querySelectorAll('[data-lf-menu-close]');
  var nav = document.querySelector('[data-lf-nav]');
  var navOverlay = document.querySelector('[data-lf-nav-overlay]');

  var shopBtn = document.querySelector('[data-lf-shop-toggle]');
  var shopPanel = document.querySelector('[data-lf-shop-panel]');
  var shopSign = document.querySelector('[data-lf-shop-sign]');

  var isHome = document.body.classList.contains('lf-template-home');

  function setHeaderState(menuOpen) {
    if (!header) return;
    var dark = isHome && !menuOpen;
    header.classList.toggle('lf-header--dark', dark);
    header.classList.toggle('lf-header--light', !dark);

    var logoLight = document.querySelector('[data-lf-logo-light]');
    var logoDark = document.querySelector('[data-lf-logo-dark]');
    if (logoLight) logoLight.style.display = dark ? 'block' : 'none';
    if (logoDark) logoDark.style.display = dark ? 'none' : 'block';
  }

  function openMenu() {
    if (nav) nav.hidden = false;
    if (navOverlay) navOverlay.hidden = false;
    document.body.classList.add('lf-menu-open');
    document.body.style.overflow = 'hidden';
    setHeaderState(true);
  }

  function closeMenu() {
    if (nav) nav.hidden = true;
    if (navOverlay) navOverlay.hidden = true;
    document.body.classList.remove('lf-menu-open');
    document.body.style.overflow = '';
    setHeaderState(false);
  }

  setHeaderState(false);

  if (menuBtn) menuBtn.addEventListener('click', function () {
    var isOpen = nav && !nav.hidden;
    isOpen ? closeMenu() : openMenu();
  });
  menuClose.forEach(function (el) { el.addEventListener('click', closeMenu); });

  if (shopBtn && shopPanel) {
    shopBtn.addEventListener('click', function () {
      var expanded = shopPanel.hidden === false;
      shopPanel.hidden = expanded;
      if (shopSign) shopSign.textContent = expanded ? '+' : '–';
    });
  }

  // ===== PDP accordions =====
  document.querySelectorAll('[data-lf-acc-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var body = btn.parentElement.querySelector('[data-lf-acc-body]');
      var sign = btn.querySelector('[data-lf-acc-sign]');
      if (!body) return;
      var isOpen = body.hidden === false;
      body.hidden = isOpen;
      if (sign) sign.textContent = isOpen ? '+' : '–';
    });
  });

  // ===== Auth tabs =====
  document.querySelectorAll('[data-lf-auth-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.getAttribute('data-lf-auth-tab');
      document.querySelectorAll('[data-lf-auth-tab]').forEach(function (t) {
        t.classList.toggle('is-active', t === tab);
      });
      document.querySelectorAll('[data-lf-auth-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-lf-auth-panel') !== target;
      });
    });
  });

  var forgotBtn = document.querySelector('[data-lf-forgot-toggle]');
  var recoverPanel = document.querySelector('[data-lf-recover-panel]');
  var signinPanel = document.querySelector('[data-lf-auth-panel="signin"]');
  if (forgotBtn && recoverPanel) {
    forgotBtn.addEventListener('click', function () {
      recoverPanel.hidden = !recoverPanel.hidden;
      if (signinPanel) signinPanel.hidden = !recoverPanel.hidden;
    });
  }

  // ===== PDP thumbnail gallery =====
  var pdpGallery = document.getElementById('pdp-gallery');
  document.querySelectorAll('[data-lf-thumb]').forEach(function (thumb, i) {
    thumb.addEventListener('click', function () {
      if (pdpGallery) pdpGallery.scrollTo({ left: pdpGallery.clientWidth * i, behavior: 'smooth' });
      document.querySelectorAll('[data-lf-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
});

// ===== LA FIRMA — Cart Drawer =====
(function () {
  var drawer = document.querySelector('[data-lf-cart-drawer]');
  var overlay = document.querySelector('[data-lf-drawer-overlay]');
  var closeBtn = document.querySelector('[data-lf-drawer-close]');
  var body = document.querySelector('[data-lf-drawer-body]');
  var foot = document.querySelector('[data-lf-drawer-foot]');
  if (!drawer) return;

  function formatMoney(cents) {
    return 'R\u00a0' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function openDrawer() {
    drawer.classList.add('lf-is-open');
    if (overlay) overlay.classList.add('lf-is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('lf-is-open');
    if (overlay) overlay.classList.remove('lf-is-open');
    document.body.style.overflow = '';
  }

  function updateCartCount(count) {
    var btn = document.querySelector('[data-lf-cart-toggle]');
    if (btn) btn.textContent = 'Cart (' + count + ')';
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderDrawer(cart);
      updateCartCount(cart.item_count);
    });
  }

  function renderDrawer(cart) {
    if (!body || !foot) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="lf-cart-drawer__empty">Your cart is empty.</p>';
      foot.innerHTML = '';
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      return '<div class="lf-drawer-item">' +
        '<img class="lf-drawer-item__img" src="' + (item.image || '') + '" alt="' + item.product_title + '">' +
        '<div class="lf-drawer-item__info">' +
          '<p class="lf-drawer-item__vendor">' + item.vendor + '</p>' +
          '<p class="lf-drawer-item__title">' + item.product_title + '</p>' +
          (item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="lf-drawer-item__variant">' + item.variant_title + '</p>' : '') +
          '<div class="lf-drawer-item__meta">' +
            '<div class="lf-drawer-item__qty-wrap">' +
              '<button class="lf-drawer-item__qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
              '<span class="lf-drawer-item__qty">' + item.quantity + '</span>' +
              '<button class="lf-drawer-item__qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
            '</div>' +
            '<p class="lf-drawer-item__price">' + formatMoney(item.final_line_price) + '</p>' +
          '</div>' +
          '<button class="lf-drawer-item__remove" data-key="' + item.key + '" data-qty="0">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');

    foot.innerHTML =
      '<div class="lf-drawer-subtotal">' +
        '<span class="lf-drawer-subtotal__label">Subtotal</span>' +
        '<span class="lf-drawer-subtotal__value">' + formatMoney(cart.total_price) + '</span>' +
      '</div>' +
      '<p class="lf-drawer-subtotal__note">Shipping calculated at checkout.</p>' +
      '<a href="/cart" class="lf-drawer__checkout-btn">Proceed to Checkout</a>';

    body.querySelectorAll('[data-key][data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeQty(btn.dataset.key, parseInt(btn.dataset.qty, 10));
      });
    });
  }

  // Intercept Add to Cart
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.lf-pdp-addbtn');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var form = btn.closest('form');
    if (!form) return;
    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    })
    .then(function () { return fetch('/cart.js'); })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderDrawer(cart);
      updateCartCount(cart.item_count);
      openDrawer();
    });
  });

  // Header cart button opens drawer
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lf-cart-toggle]');
    if (!btn) return;
    e.preventDefault();
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        openDrawer();
      });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
})();

// ===== LA FIRMA — Intro Splash =====
(function () {
  var SPLASH_KEY = 'lfSplashShown';
  var splash = document.querySelector('[data-lf-splash]');
  if (!splash) return;

  if (sessionStorage.getItem(SPLASH_KEY)) {
    splash.remove();
    return;
  }
  sessionStorage.setItem(SPLASH_KEY, '1');

  document.documentElement.classList.add('lf-splash-active');

  var svgNS = 'http://www.w3.org/2000/svg';
  var svg = splash.querySelector('.lf-splash__logo');
  var paths = Array.prototype.slice.call(svg.querySelectorAll('path'));

  // Sort left-to-right so letters draw in reading order (L-A-F-I-R-M-A).
  paths.sort(function (a, b) {
    return a.getBBox().x - b.getBBox().x;
  });

  var lengths = paths.map(function (path) { return path.getTotalLength(); });
  var totalLength = lengths.reduce(function (a, b) { return a + b; }, 0);
  var bboxes = paths.map(function (p) { return p.getBBox(); });

  function easeInOut(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }

  var totalDrawTime = 3600; // ms budgeted across all letters, stroke+fill combined
  var overlap = 100;        // next letter starts slightly before this one settles
  var minDuration = 320;    // floor so short letters don't flash by instantly

  var fillLagRatio = 0.32;   // fill starts once the stroke is this far along
  var fillPad = 2;

  var durations = lengths.map(function (len) {
    return Math.max(minDuration, (len / totalLength) * totalDrawTime);
  });

  var startDelays = [];
  var acc = 0;
  durations.forEach(function (d) {
    startDelays.push(acc);
    acc += d - overlap;
  });
  var totalAnimTime = startDelays[startDelays.length - 1] + durations[durations.length - 1];

  var defs = svg.querySelector('defs');
  if (!defs) {
    defs = document.createElementNS(svgNS, 'defs');
    svg.insertBefore(defs, svg.firstChild);
  }

  paths.forEach(function (path, i) {
    var len = lengths[i];
    var duration = durations[i];
    var bb = bboxes[i];

    // Stroke setup
    path.style.fill = 'none';
    path.style.stroke = '#FFFDFA';
    path.style.strokeWidth = '1.2';
    path.style.strokeLinecap = 'round';
    path.style.strokeLinejoin = 'round';
    path.style.strokeDasharray = len;
    path.style.strokeDashoffset = len;

    // Fill setup — clip rect starts at zero width, sits ready to wipe in
    var clipId = 'lfFillClip' + i;
    var clipPath = document.createElementNS(svgNS, 'clipPath');
    clipPath.setAttribute('id', clipId);
    var rect = document.createElementNS(svgNS, 'rect');
    rect.setAttribute('x', bb.x - fillPad);
    rect.setAttribute('y', bb.y - fillPad);
    rect.setAttribute('width', 0);
    rect.setAttribute('height', bb.height + fillPad * 2);
    clipPath.appendChild(rect);
    defs.appendChild(clipPath);

    var fillEl = path.cloneNode();
    fillEl.removeAttribute('id');
    fillEl.style.fill = '#FFFDFA';
    fillEl.style.stroke = 'none';
    fillEl.setAttribute('clip-path', 'url(#' + clipId + ')');
    path.parentNode.insertBefore(fillEl, path);

    var fullWidth = bb.width + fillPad * 2;
    var fillLag = duration * fillLagRatio;
    var fillDuration = duration - fillLag + 120; // finishes just after the stroke tip passes

    setTimeout(function () {
      var strokeStart = null;
      function strokeTick(now) {
        if (!strokeStart) strokeStart = now;
        var progress = Math.min((now - strokeStart) / duration, 1);
        path.style.strokeDashoffset = len * (1 - easeInOut(progress));
        if (progress < 1) requestAnimationFrame(strokeTick);
      }
      requestAnimationFrame(strokeTick);

      setTimeout(function () {
        var fillStart = null;
        function fillTick(now) {
          if (!fillStart) fillStart = now;
          var progress = Math.min((now - fillStart) / fillDuration, 1);
          rect.setAttribute('width', fullWidth * easeInOut(progress));
          if (progress < 1) requestAnimationFrame(fillTick);
        }
        requestAnimationFrame(fillTick);
      }, fillLag);
    }, startDelays[i]);
  });

  var hold = 500;
  var hideDelay = totalAnimTime + hold;

  setTimeout(function () {
    splash.classList.add('lf-splash--hide');
    document.documentElement.classList.remove('lf-splash-active');
  }, hideDelay);

  setTimeout(function () {
    splash.remove();
  }, hideDelay + 900);
})();
// ===== LA FIRMA — Announcement bar scroll =====
function initAnnouncementScroll() {
  const bar = document.querySelector('.lf-announcement-bar');
  const header = document.querySelector('[data-lf-header]');
  if (!bar || !header) return;
  let barHeight = bar.offsetHeight;
  function update() {
    const offset = Math.max(0, barHeight - window.scrollY);
    header.style.top = offset + 'px';
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', () => { barHeight = bar.offsetHeight; update(); });
  update();
}
document.addEventListener('DOMContentLoaded', initAnnouncementScroll);

// ===== LA FIRMA — Newsletter popup =====
function initNewsletterPopup() {
  const overlay = document.querySelector('[data-lf-popup-overlay]');
  if (!overlay) return;
  const STORAGE_KEY = 'lf_popup_dismissed';
  if (localStorage.getItem(STORAGE_KEY)) return;
  const KLAVIYO_PUBLIC_KEY = 'VW7u86';
  const KLAVIYO_LIST_ID = 'UJFD5H';
  const closeBtn = overlay.querySelector('[data-lf-popup-close]');
  const form = overlay.querySelector('[data-lf-popup-form]');
  const stepForm = overlay.querySelector('[data-lf-popup-step="form"]');
  const stepSuccess = overlay.querySelector('[data-lf-popup-step="success"]');

  function dismiss() {
    overlay.setAttribute('hidden', '');
    localStorage.setItem(STORAGE_KEY, 'true');
  }

  setTimeout(() => { overlay.removeAttribute('hidden'); }, 4000);
  closeBtn.addEventListener('click', dismiss);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) dismiss(); });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const email = overlay.querySelector('[data-lf-popup-email]').value;
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
          }
        }
      })
    }).then(() => {
      stepForm.setAttribute('hidden', '');
      stepSuccess.removeAttribute('hidden');
      localStorage.setItem(STORAGE_KEY, 'true');
    }).catch(() => {
      stepForm.setAttribute('hidden', '');
      stepSuccess.removeAttribute('hidden');
      localStorage.setItem(STORAGE_KEY, 'true');
    });
  });
}
document.addEventListener('DOMContentLoaded', initNewsletterPopup);

// ===== LA FIRMA — Search Bar =====
(function () {
  var toggles = document.querySelectorAll('[data-lf-search-toggle]');
  var bar = document.querySelector('[data-lf-search-bar]');
  var closeBtn = document.querySelector('[data-lf-search-close]');
  var input = document.querySelector('[data-lf-search-input]');
  if (!toggles.length || !bar) return;

  function openSearch() {
    bar.classList.add('lf-is-open');
    if (input) setTimeout(function () { input.focus(); }, 350);
  }

  function closeSearch() {
    bar.classList.remove('lf-is-open');
  }

  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      bar.classList.contains('lf-is-open') ? closeSearch() : openSearch();
    });
  });

  bar.addEventListener('click', function (e) {
    e.stopPropagation();
  });

  if (closeBtn) closeBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    closeSearch();
  });

  document.addEventListener('click', function (e) {
    if (bar.classList.contains('lf-is-open') && !bar.contains(e.target) && ![].some.call(toggles, function (t) { return t.contains(e.target); })) {
      closeSearch();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });
})();
// ===== Prevent iOS overscroll =====
(function () {
  var isIOS = /iP(hone|od|ad)/.test(navigator.platform) ||
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document); // iPadOS reports as Mac
  if (!isIOS) return;

  var startY = 0;

  document.addEventListener('touchstart', function (e) {
    startY = e.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    var el = e.target;
    while (el && el !== document.body) {
      var style = window.getComputedStyle(el);
      var overflowY = style.getPropertyValue('overflow-y');
      var isScrollable = (overflowY === 'auto' || overflowY === 'scroll');
      if (isScrollable && el.scrollHeight > el.clientHeight) {
        var atTop = el.scrollTop === 0;
        var atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight;
        var deltaY = e.touches[0].clientY - startY;
        if ((atTop && deltaY > 0) || (atBottom && deltaY < 0)) {
          e.preventDefault();
        }
        return;
      }
      el = el.parentElement;
    }

    var deltaYPage = e.touches[0].clientY - startY;
    var pageAtBottom = document.documentElement.scrollTop + window.innerHeight >= document.documentElement.scrollHeight;
    var pageAtTop = document.documentElement.scrollTop <= 0;
    if ((pageAtBottom && deltaYPage < 0) || (pageAtTop && deltaYPage > 0)) {
      e.preventDefault();
    }
  }, { passive: false });
})();

// ===== PDP gallery arrows =====
(function(){
  var gallery = document.getElementById('pdp-gallery');
  var prevBtn = document.querySelector('[data-lf-gallery-prev]');
  var nextBtn = document.querySelector('[data-lf-gallery-next]');
  var thumbs = document.querySelectorAll('[data-lf-thumb]');
  if (!gallery || !thumbs.length) return;

  var total = thumbs.length;
  var current = 0;

  function goTo(i) {
    current = ((i % total) + total) % total;
    gallery.scrollTo({ left: gallery.clientWidth * current, behavior: 'smooth' });
    thumbs.forEach(function(t) { t.classList.remove('is-active'); });
    thumbs[current].classList.add('is-active');
  }

  if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

  thumbs.forEach(function(thumb, i) {
    thumb.addEventListener('click', function() { goTo(i); });
  });
})();
window.addEventListener('pageshow', function () {
  document.body.classList.remove('lf-menu-open');
  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';
});
